import React, {useContext} from 'react';
import {alpha, styled} from "@mui/material/styles";
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import {useNavigate} from "react-router-dom";
import PageContextZiggy from "../../store/page-context-ziggy";
import {IconButton} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import {PageContext} from "@lb/mlib-components";

const MySearch = () => {

    const Search = styled('div')(({theme}) => ({
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    }));

    const SearchIconWrapper = styled('div')(({theme}) => ({
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }));

    const StyledInputBase = styled(InputBase)(({theme}) => ({
        color: 'inherit',
        '& .MuiInputBase-input': {
            padding: theme.spacing(1, 1, 1, 0),
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4)})`,
            transition: theme.transitions.create('width'),
            width: '100%',
            [theme.breakpoints.up('md')]: {
                width: '20ch',
            },
        },
    }));
    const navigate = useNavigate();
    const pageCtxZiggy = useContext(PageContextZiggy);
    const pageCtx = useContext(PageContext);

    const [search, setSearch] = React.useState(pageCtxZiggy.search || '');
    const handleChangeSearch = (event) => {
        if (event.target.value.length > 0 && pageCtx.currentUrl !== '/globalsearch')
            navigate('globalsearch')

        setSearch(event.target.value);
        pageCtxZiggy.updateSearch(event.target.value)
    };


    function handleClearClick() {
        setSearch('');
        pageCtxZiggy.updateSearch('')
        navigate(-1)
    }

    return (<>
            <Search>
                <SearchIconWrapper>
                    <SearchIcon/>
                </SearchIconWrapper>
                <StyledInputBase
                    key="search"
                    autoFocus={pageCtx.title === 'Global Search'}
                    placeholder="Search…"
                    inputProps={{'aria-label': 'search'}}
                    value={search}
                    onChange={handleChangeSearch}
                    endAdornment={<IconButton sx={{color: 'white', visibility: search ? "visible" : "hidden"}}
                                              onClick={handleClearClick}><ClearIcon/></IconButton>}
                />
            </Search>
        </>
    );
};

export default MySearch;
